/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The BrandJson model module.
 * @module model/BrandJson
 * @version v1
 */
export class BrandJson {
  /**
   * Constructs a new <code>BrandJson</code>.
   * @alias module:model/BrandJson
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>BrandJson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BrandJson} obj Optional instance to populate.
   * @return {module:model/BrandJson} The populated <code>BrandJson</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BrandJson();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
BrandJson.prototype.id = undefined;

/**
 * @member {String} image_url
 */
BrandJson.prototype.image_url = undefined;

/**
 * @member {String} name
 */
BrandJson.prototype.name = undefined;

